// OneTimePaymentModal.jsx
import React, { useState, useEffect } from 'react';
import { PaymentElement, useStripe, useElements, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import './StripeModal.css';

// Initialize Stripe with your publishable key.
const stripePromise = loadStripe('pk_live_51QQM6GAWnK0AWkSwLhhM1x0dpXfs0vOaKgLseLjmI80FlABs7Gtuub9L75lBxSyl3BCOgyhxpmZdk6hyOUUF7AIr00Xd9Ha4m2');

const OneTimePaymentModal = ({ onPaymentSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();

  // State for the one-time payment option.
  const [oneTimeLoading, setOneTimeLoading] = useState(false);
  const [oneTimeError, setOneTimeError] = useState(null);

  // One-time payment handler (89¢)
  const handleOneTimeSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setOneTimeLoading(true);
    setOneTimeError(null);

    const { error: confirmError } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: 'if_required',
    });

    if (confirmError) {
      setOneTimeError(confirmError.message);
      setOneTimeLoading(false);
      return;
    }

    // On successful one-time payment:
    onPaymentSuccess();
  };

  return (
      <div className="payment-option one-time">
        <h2>Get Your AI-Enhanced Resume</h2>
        <p className="modal-subtitle">
          One-time payment to unlock your professionally crafted, AI-enhanced resume.
          Invest in your future success now!
        </p>
        <h2>One Time Payment of $0.89</h2>
        <form onSubmit={handleOneTimeSubmit} className="payment-form">
          <PaymentElement options={{ layout: 'tabs' }} />
          {oneTimeError && <div className="error-message">{oneTimeError}</div>}
          <button type="submit" disabled={!stripe || oneTimeLoading} className="pay-button">
            {oneTimeLoading ? 'Processing...' : 'Pay Now'}
          </button>
        </form>
      </div>
  );
};

// This component fetches the client secret and wraps the content in <Elements>.
const OneTimePaymentModalContent = ({ isOpen, onClose, onPaymentSuccess }) => {
  const [clientSecret, setClientSecret] = useState(null);

  useEffect(() => {
    if (isOpen) {
      const fetchClientSecret = async () => {
        try {
          const functions = getFunctions();
          const createPaymentIntent = httpsCallable(functions, 'createPaymentIntent');
          const result = await createPaymentIntent();
          setClientSecret(result.data.clientSecret);
        } catch (error) {
          console.error('Error fetching client secret:', error);
        }
      };
      fetchClientSecret();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="one-time-payment-card">
      {!clientSecret ? (
        <div>Loading Payment...</div>
      ) : (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <OneTimePaymentModal onPaymentSuccess={onPaymentSuccess} onClose={onClose} />
        </Elements>
      )}
    </div>
  );
};

export default OneTimePaymentModalContent;
